import { splitTime } from '@/shared/lib/formatTime';

export const formatTime = (valueRoundSeconds: number, referenceRoundSeconds = 0) => {
    const [hours, minutes, seconds] = splitTime(valueRoundSeconds);
    const [referenceHours, referenceMinutes] = splitTime(referenceRoundSeconds);

    const groups = [];
    if (hours) {
        groups.push(String(hours).padStart(2, '0'));
    } else if (referenceHours) {
        groups.push('00');
    }

    if (minutes || hours) {
        groups.push(String(minutes).padStart(2, '0'));
    } else if (referenceMinutes || referenceHours) {
        groups.push('00');
    }

    groups.push(String(seconds).padStart(2, '0'));

    return [
        groups.join(':'),
        {
            numbers: groups.reduce((sum, str) => sum + str.length, 0),
            colons: groups.length - 1,
        },
    ] as const;
};
